import { useQuery } from "@tanstack/react-query";
import i18n from "i18n";
import { AIFeatureModels } from "@graylog/enterprise-api";
import { defaultOnError } from "util/conditional/onError";
export const FEATURE_MODELS_QUERY_KEY = ["ai-management", "feature-models"];
export const fetchFeatureModels = () => AIFeatureModels.list();
const useFeatureModels = (disabled = false) => {
  const { data, isLoading } = useQuery({
    queryKey: FEATURE_MODELS_QUERY_KEY,
    queryFn: () => defaultOnError(
      fetchFeatureModels(),
      i18n.t("notifications.feature_models_load_message", { ns: "enterprise_ai" }),
      i18n.t("notifications.feature_models_load_title", { ns: "enterprise_ai" })
    ),
    enabled: !disabled
  });
  return { data: data != null ? data : [], isLoading };
};
export default useFeatureModels;
